<script>
import * as auth from '@/auth'

const { onLogin, onLogout, emitChecked, onUpdateUser } = auth
const USER_STORAGE_KEY = 'user'

export default {
  data() {
    return {
      user: null,
    }
  },

  mounted() {
    onLogin(({ afiliado }) => this.login(afiliado))
    onLogout(() => this.logout())
    onUpdateUser(({ user }) => this.storeUser(user))

    this.checkSession()
  },

  render() {
    return this.$scopedSlots.default({
      authenticated: this.authenticated,
      user: this.user,
    })
  },

  computed: {
    authenticated() {
      return this.user !== null
    },
  },

  methods: {
    logout() {
      localStorage.clear()
      this.user = null
      this.checkSession()
    },

    checkSession() {
      emitChecked({ checked: false })

      if (this.hasUserInStorage()) {
        this.user = JSON.parse(this.storageUser())
      }

      emitChecked({ checked: true })
    },

    login(afiliado) {
      this.storeUser(afiliado)
      this.user = afiliado
    },

    storageUser() {
      return localStorage.getItem(USER_STORAGE_KEY)
    },

    hasUserInStorage() {
      return this.storageUser !== null
    },

    storeUser(user) {
      localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user))
    },
  },
}
</script>
